export const DefaultLocale = 'EN';

// export const BACKEND_URL = 'https://calahex.io/api/';
// export const BACKEND_URL = 'http://127.0.0.1:8000/api/';

export const PUBLIC_API_URL = "https://poloniex.com/public?" ;

export const PUBULIC_EXCHANGE_RATE_API = "https://api.coinbase.com/v2/exchange-rates?currency=" ;

export const PRIVATE_REMITFIX_API = "http://localhost:5000/remitfix/api/" ;
export const PUBLIC_REMITFIX_API = "http://localhost:5000/remitfix/files/";
